import { useEffect } from 'react';

/**
 * The privacy page is a static file (public/privacy.html), so it is readable without
 * JavaScript, as Google's OAuth review requires. Opening /privacy directly serves that file;
 * this component only handles in-app links, by loading the static page.
 */
export default function Privacy() {
  useEffect(() => { window.location.replace('/privacy.html'); }, []);
  return null;
}
